import React, { useState } from 'react';
import config from "../config";
import './MediaForm.css';
import SuccessModal from './modelpopup'; // Import the SuccessModal component

const MediaForm = ({ onClose, onSuccess }) => {
  const [isFileInput, setIsFileInput] = useState(false);
  const [mediaUrl, setMediaUrl] = useState('');
  const [mediaFile, setMediaFile] = useState(null);
  const [mediaCategory, setMediaCategory] = useState('');
  const [mediaType, setMediaType] = useState('');
  const [error, setError] = useState(''); 
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false); 

  const handleFileChange = (e) => {
    setMediaFile(e.target.files[0]);
  };

  const handleUrlChange = (e) => {
    setMediaUrl(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validation checks
    if (!mediaCategory || !mediaType) {
      setError('Please select both media category and type.');
      return;
    }

    const formData = new FormData();
    if (isFileInput && mediaFile) {
      formData.append('file', mediaFile);
    } else if (!isFileInput && mediaUrl) {
      formData.append('media_url', mediaUrl); // Corrected key name here
    } else {
      setError('Please provide either a media file or media URL.');
      return;
    }

    formData.append('mediaCategory', mediaCategory);
    formData.append('mediaType', mediaType);

    // Use dynamic backend URL from config.js
    fetch(`${config.backendUrl}/api/submit_media`, {
      method: 'POST',
      body: formData,
    })
    .then(response => response.json())
    .then(data => {
      if (data.message) {
        setIsSuccessModalVisible(true); 
        setTimeout(() => {
          setIsSuccessModalVisible(false);
          onSuccess(); 
        }, 3000);
      } else {
        setError(data.error || 'An error occurred while submitting the media.');
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      setError('Error submitting media');
    });
  };

  return (
    <div className="center-wrapper">
      <div className="media-form-container">
        <div className="media-form-header">
          <h3>Insert Media</h3>
          <button className="close-button" onClick={onClose}>
            ✖
          </button>
        </div>
        <form onSubmit={handleSubmit} className="media-form">
          {/* Display error if any */}
          {error && <div className="error-message">{error}</div>}

          {/* Media URL or File Selection */}
          <div className="form-group">
            <label htmlFor="mediaChoice">Choose Media Input</label>
            <div>
              <label>
                <input
                  type="radio"
                  name="mediaChoice"
                  checked={!isFileInput}
                  onChange={() => setIsFileInput(false)}
                />
                Enter Media URL
              </label>
              <label>
                <input
                  type="radio"
                  name="mediaChoice"
                  checked={isFileInput}
                  onChange={() => setIsFileInput(true)}
                />
                Select Media File
              </label>
            </div>
          </div>

          {/* Media URL Input */}
          {!isFileInput && (
            <div className="form-group">
              <label htmlFor="mediaUrl">Media URL</label>
              <input
                type="text"
                id="mediaUrl"
                className="form-control"
                placeholder="Enter media URL"
                value={mediaUrl}
                onChange={handleUrlChange}
              />
            </div>
          )}

          {/* Media File Input */}
          {isFileInput && (
            <div className="form-group">
              <label htmlFor="mediaFile">Media File</label>
              <input
                type="file"
                id="mediaFile"
                className="form-control"
                onChange={handleFileChange}
              />
              {mediaFile && <p>Selected file: {mediaFile.name}</p>}
            </div>
          )}

          {/* Media Category Dropdown */}
          <div className="form-group">
            <label htmlFor="mediaCategory">Media Category</label>
            <select
              id="mediaCategory"
              className="form-control"
              value={mediaCategory}
              onChange={(e) => setMediaCategory(e.target.value)}
            >
              <option value="">Select Category</option>
              <option value="Free English Speaking Class Photos">
                Free English Speaking Class Photos
              </option>
              <option value="ISRO Show">ISRO Show</option>
              <option value="Free Cyber Security Session in Gov. School">
                Free Cyber Security Session in Gov. School
              </option>
            </select>
          </div>

          {/* Media Type Dropdown */}
          <div className="form-group">
            <label htmlFor="mediaType">Media Type</label>
            <select
              id="mediaType"
              className="form-control"
              value={mediaType}
              onChange={(e) => setMediaType(e.target.value)}
            >
              <option value="">Select Media Type</option>
              <option value="Photo">Photo</option>
              <option value="Video">Video</option>
            </select>
          </div>

          {/* Submit Button */}
          <button type="submit" className="btn">
            Submit
          </button>
        </form>

        {/* Show Success Modal */}
        {isSuccessModalVisible && (
          <SuccessModal message="Media submitted successfully!" onClose={() => setIsSuccessModalVisible(false)} />
        )}
      </div>
    </div>
  );
};

export default MediaForm;
